import visaLogo from '@/features/payments/assets/logo-visa.svg';
import mastercardLogo from '@/features/payments/assets/logo-mastercard.svg';
import maestroLogo from '@/features/payments/assets/logo-maestro.svg';
import applePayMark from '@/features/payments/assets/logo-apple-pay-mark.svg';
import shieldIcon from '@/features/payments/assets/icon-shield.svg';

const LOGOS = [
  { src: visaLogo, alt: 'Visa', className: 'h-3 w-[37px]' },
  { src: mastercardLogo, alt: 'Mastercard', className: 'h-6 w-[31px]' },
  { src: maestroLogo, alt: 'Maestro', className: 'h-6 w-[31px]' },
  { src: applePayMark, alt: 'Apple Pay', className: 'h-4 w-[38px]' },
] as const;

interface OfferDisclaimerProps {
  copy: string;
}

export function OfferDisclaimer({ copy }: OfferDisclaimerProps) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-[24px] border border-mf-neutral-200 p-4">
      <div className="flex w-full flex-col items-center gap-2">
        <p className="font-body text-sm font-bold leading-4 text-mf-neutral-900">Safe &amp; Secure Payment</p>
        <div className="flex w-full gap-1">
          {LOGOS.map((logo) => (
            <div
              key={logo.alt}
              className="flex h-10 flex-1 items-center justify-center rounded-lg bg-white"
            >
              <img src={logo.src} alt={logo.alt} className={logo.className} />
            </div>
          ))}
        </div>
      </div>
      <div className="h-px w-full bg-mf-neutral-200" />
      <div className="flex w-full flex-col items-center gap-2">
        <div className="flex items-center justify-center gap-1 rounded-[20px] bg-white px-4 py-2 shadow-[0_0_8px_rgba(26,22,19,0.03)]">
          <img src={shieldIcon} alt="" className="size-[18px] object-contain" />
          <span className="font-body text-sm font-bold leading-4 text-mf-neutral-900">
            100% money back guarantee
          </span>
        </div>
        <p className="text-center font-body text-xs font-normal leading-4 text-mf-neutral-400">{copy}</p>
      </div>
    </div>
  );
}
